<template>
  <div class="template-padding">
    <form @submit="editTrainingCenter">
      <div class="row">
        <div class="col col-sm-6">
          <h4 class="font-weight-bolder">
            TRAINING CENTER DETAILS
          </h4>
        </div>
        <div class="col col-sm-6 text-right">
          <button
            type="submit"
            class="btn btn-sm btn-warning font-weight-bolder mr-3"
          >
            <span><i class="fas fa-edit" /></span>
            {{ trainingCenterEditable ? 'UPDATE':'EDIT' }}
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary font-weight-bolder"
            id="cancelButton"
            v-if="trainingCenterEditable"
            @click="cancelTrainingCenterEditable"
          >
            <span><i class="fas fa-ban" /></span>
            CANCEL
          </button>
          <button
            class="btn btn-sm btn-outline-secondary font-weight-bolder"
            @click="goBack"
          >
            <span><i class="fas fa-backward" /></span>GO BACK
          </button>
        </div>
      </div>
      <hr class="hr-color">
      <div class="card">
        <div class="card-body row">
          <div class="col col-sm-6">
            <div
              class="form-group form-row"
              :class="{'has-error': errorTrainingCenterUpdate.code !== ''}"
            >
              <label
                class="col col-sm-2 col-form-label font-weight-bolder text-right"
                for="code"
              >CODE:</label>
              <div class="col col-sm-10">
                <input
                  type="text"
                  name="code"
                  id="code"
                  class="form-control form-control-xs"
                  placeholder="TRAINING CENTER CODE"
                  v-model="trainingCenter.code"
                  :readonly="!trainingCenterEditable"
                  @input="capitalize($event, trainingCenter, 'code')"
                >
                <span
                  class="help-block"
                  v-if="errorTrainingCenterUpdate.code !== ''"
                >
                  <small><strong>{{ errorTrainingCenterUpdate.code }}</strong></small>
                </span>
              </div>
            </div>

            <div
              class="form-group form-row"
              :class="{'has-error': errorTrainingCenterUpdate.name !== ''}"
            >
              <div class="col col-sm-2 col-form-label font-weight-bolder text-right">
                NAME:
              </div>
              <div class="col col-sm-10">
                <input
                  type="text"
                  name="name"
                  id="name"
                  class="form-control form-control-xs"
                  placeholder="TRAINING CENTER NAME"
                  v-model="trainingCenter.name"
                  :readonly="!trainingCenterEditable"
                  @input="capitalize($event, trainingCenter, 'name')"
                >
                <span
                  class="help-block"
                  v-if="errorTrainingCenterUpdate.name !== ''"
                >
                  <small><strong>{{ errorTrainingCenterUpdate.name }}</strong></small>
                </span>
              </div>
            </div>

            <div
              class="form-group form-row"
              :class="{'has-error': errorTrainingCenterUpdate.email !== ''}"
            >
              <div class="col col-sm-2 col-form-label font-weight-bolder text-right">
                EMAIL:
              </div>
              <div class="col col-sm-10">
                <input
                  type="text"
                  name="email"
                  id="email"
                  placeholder="TRAINING CENTER EMAIL"
                  class="form-control form-control-xs"
                  v-model="trainingCenter.email"
                  :readonly="!trainingCenterEditable"
                >
                <span
                  class="help-block"
                  v-if="errorTrainingCenterUpdate.email !== ''"
                >
                  <small><strong>{{ errorTrainingCenterUpdate.email }}</strong></small>
                </span>
              </div>
            </div>

            <div class="form-group form-row">
              <div class="col col-sm-2 col-form-label font-weight-bolder text-right">
                STATUS:
              </div>
              <div class="col col-sm-1">
                <input
                  type="checkbox"
                  name="status"
                  id="status"
                  class="form-control form-control-xs"
                  v-model="trainingCenter.status"
                  :disabled="!trainingCenterEditable"
                >
              </div>
              <label class="col-sm-3 col-form-label font-weight-bolder">
                {{ trainingCenter.status ? 'ACTIVE':'INACTIVE' }}
              </label>
            </div>
          </div>

          <div class="col col-sm-6">
            <div
              class="form-group form-row"
              :class="{'has-error': errorTrainingCenterUpdate.contact_number !== ''}"
            >
              <label
                class="col col-sm-3 col-form-label font-weight-bolder text-right"
                for="contact_number"
              >CONTACT NUMBER: </label>
              <div class="col col-sm-9">
                <input
                  type="text"
                  name="contact_number"
                  id="contact_number"
                  maxlength="50"
                  class="form-control form-control-xs"
                  placeholder="TRAINING CENTER CONTACT NUMBER"
                  v-model="trainingCenter.contact_number"
                  :readonly="!trainingCenterEditable"
                  @input="capitalize($event, trainingCenter, 'contact_number')"
                >
                <span
                  class="help-block"
                  v-if="errorTrainingCenterUpdate.contact_number !== ''"
                >
                  <small><strong>{{ errorTrainingCenterUpdate.contact_number }}</strong></small>
                </span>
              </div>
            </div>

            <div
              class="form-group form-row"
              :class="{'has-error': errorTrainingCenterUpdate.contact_person !== ''}"
            >
              <label
                class="col col-sm-3 col-form-label font-weight-bolder text-right"
                for="contact_number"
              >CONTACT PERSON: </label>
              <div class="col col-sm-9">
                <input
                  type="text"
                  name="contact_person"
                  id="contact_person"
                  maxlength="50"
                  class="form-control form-control-xs"
                  placeholder="TRAINING CENTER CONTACT PERSON"
                  v-model="trainingCenter.contact_person"
                  :readonly="!trainingCenterEditable"
                  @input="capitalize($event, trainingCenter, 'contact_person')"
                >
                <span
                  class="help-block"
                  v-if="errorTrainingCenterUpdate.contact_person !== ''"
                >
                  <small><strong>{{ errorTrainingCenterUpdate.contact_person }}</strong></small>
                </span>
              </div>
            </div>

            <div
              class="form-group form-row"
              :class="{'has-error': errorTrainingCenterUpdate.faxno !== ''}"
            >
              <label
                class="col col-sm-3 col-form-label font-weight-bolder text-right"
                for="faxno"
              >FAX NUMBER: </label>
              <div class="col col-sm-9">
                <input
                  type="text"
                  name="faxno"
                  id="faxno"
                  maxlength="50"
                  class="form-control form-control-xs"
                  placeholder="TRAINING CENTER FAX NUMBER"
                  v-model="trainingCenter.faxno"
                  :readonly="!trainingCenterEditable"
                  @input="capitalize($event, trainingCenter, 'faxno')"
                >
                <span
                  class="help-block"
                  v-if="errorTrainingCenterUpdate.faxno !== ''"
                >
                  <small><strong>{{ errorTrainingCenterUpdate.faxno }}</strong></small>
                </span>
              </div>
            </div>
          </div>

          <div class="col col-sm-12">
            <div
              class="form-group"
              :class="{'has-error': errorTrainingCenterUpdate.address !== ''}"
            >
              <label
                class="font-weight-bolder"
                for="address"
              >ADDRESS: </label>
              <textarea
                name="address"
                id="address"
                rows="4"
                class="form-control form-control-xs"
                placeholder="TRAINING CENTER ADDRESS"
                v-model="trainingCenter.address"
                :readonly="!trainingCenterEditable"
                @input="capitalize($event, trainingCenter, 'address')"
              />
              <span
                class="help-block"
                v-if="errorTrainingCenterUpdate.address !== ''"
              >
                <small><strong>{{ errorTrainingCenterUpdate.address }}</strong></small>
              </span>
            </div>
          </div>

          <div class="col col-sm-12">
            <hr style="border-color: black;">
          </div>

          <div class="col col-sm-12">
            <div class="row">
              <div class="col col-sm-6">
                <div class="form-group form-row">
                  <div class="col col-sm-2 col-form-label font-weight-bolder text-right">
                    CREATED BY:
                  </div>
                  <div class="col col-sm-10">
                    <input
                      type="text"
                      class="form-control form-control-xs"
                      placeholder="SYSTEM GENERATED"
                      disabled
                      :value="createdBy"
                    >
                  </div>
                </div>

                <div class="form-group form-row">
                  <div class="col col-sm-2 col-form-label font-weight-bolder text-right">
                    CREATED AT:
                  </div>
                  <div class="col col-sm-10">
                    <input
                      type="text"
                      class="form-control form-control-xs"
                      placeholder="SYSTEM GENERATED"
                      disabled
                      :value="trainingCenter.created_at | moment('D MMM YYYY hh:m A')"
                    >
                  </div>
                </div>
              </div>

              <div class="col col-sm-6">
                <div class="form-group form-row">
                  <div class="col col-sm-3 col-form-label font-weight-bolder text-right">
                    LAST UPDATED BY:
                  </div>
                  <div class="col col-sm-9">
                    <input
                      type="text"
                      class="form-control form-control-xs"
                      placeholder="SYSTEM GENERATED"
                      disabled
                      :value="updatedBy"
                    >
                  </div>
                </div>

                <div class="form-group form-row">
                  <div class="col col-sm-3 col-form-label font-weight-bolder text-right">
                    LAST UPDATED AT:
                  </div>
                  <div class="col col-sm-9">
                    <input
                      type="text"
                      class="form-control form-control-xs"
                      placeholder="SYSTEM GENERATED"
                      disabled
                      :value="trainingCenter.updated_at | moment('D MMM YYYY hh:m A') "
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <br>

    <app-training-center-schedule />
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { formMixins } from "../../../mixins/formMixins";
    import TrainingCenterSchedule from "./schedules/TrainingCenterSchedule";

    export default {
        mixins: [formMixins],
        name: 'ViewTrainingCenter',
        methods: {
            ...mapActions([ 'toggleTrainingCenterEditable', 'getTrainingCenter', 'updateTrainingCenter' ]),
            async editTrainingCenter(e) {
                e.preventDefault();
                if(this.trainingCenterEditable) {
                    if(await this.confirmUpdateAlert('Are you sure you want to edit this training provider?')) {
                        if(await this.updateTrainingCenter()) {
                            this.successAlert('Training Center Successfully Updated', 'UPDATE');
                        } else {
                            this.errorAlert(this.generateErrorMessage(this.errorTrainingCenterUpdate), 'UPDATE RECORD');
                        }
                    }
                } else {
                    this.toggleTrainingCenterEditable();
                }
            },
            cancelTrainingCenterEditable() {
                this.toggleTrainingCenterEditable();
            }
        },
        computed: {
            ...mapGetters([ 'trainingCenter', 'trainingCenterEditable', 'errorTrainingCenterUpdate' ]),
            createdBy() {
                if(this.trainingCenter.created_by) {
                    let user = this.trainingCenter.created_by;
                    return `${user.name} ${user.middle_name.charAt(0)}. ${user.last_name}`;
                }
                return '';
            },
            updatedBy() {
                if(this.trainingCenter.updated_by) {
                    let user = this.trainingCenter.updated_by;
                    return `${user.name} ${user.middle_name.charAt(0)}. ${user.last_name}`;
                }
                return '';
            }

        },
        created() {
            this.getTrainingCenter(this.$route.params.id);
        },
        components: {
            'app-training-center-schedule': TrainingCenterSchedule
        }
    };
</script>

<style scoped>

</style>
